import { render, staticRenderFns } from "./AggiungiPrenotazione.vue?vue&type=template&id=81d85b46"
import script from "./AggiungiPrenotazione.vue?vue&type=script&lang=js"
export * from "./AggiungiPrenotazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports